module.exports = __webpack_public_path__ + "img/daylight_screen.ca6e79b5.png";